<template lang="html">
  <img :src="logo" alt="" class="logo-img">
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultLogo from '@/common/assets/img/logo-patrim.svg'
export default {
	name: 'logo',
	data () {
		return {
			defaultLogo: DefaultLogo
		}
	},
	computed: {
		...mapGetters({
			theme: 'currentTheme'
		}),
		logo () {
			if (this.theme && this.theme.logo) {
				return `${process.env.API_ROOT}api/office-asset/${this.theme.logo.file}`
			}
			return this.defaultLogo
		}
	}
}
</script>

<style lang="scss">
  .logo-img {
		width: 200px;
    max-height: 125px;
		vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// Logo.vue?f41091b6